import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-language-changer',
  templateUrl: './language-changer.component.html',
  styleUrls: ['./language-changer.component.css'],
})
export class LanguageChangerComponent implements OnInit {
  items: MenuItem[] = [];
  selectedLang$ = this.languageService.selectedLang$;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.languageService.selectedLang$.subscribe(lang => {
      this.items = [
        {
          label: lang?.code === 'it-IT' ? 'Italiano' : 'Italian',
          icon: 'it-it-icon',
          command: this.onClick,
          state: {
            lang: 'it-IT',
          },
        },
        // {
        //   label: lang?.code === 'it-IT' ? 'Inglese' : 'English',
        //   icon: 'en-gb-icon',
        //   command: this.onClick,
        //   state: {
        //     lang: 'en-GB',
        //   },
        // },
      ];    });
  }

  onClick = (event: { item: MenuItem; originalEvent: Event }) => {
    this.languageService.setLang({
      code: event.item.state?.lang,
      icon: event.item.icon || ''
    });
  }
}
